module.exports = __webpack_public_path__ + "static/media/concert2.1887a20f.jpg";